import { createAction, props } from '@ngrx/store';
import { List } from '@epicuro-next/models/engagement';

/**
 * Action to get a single ProductList
 */
export const loadProductList = createAction(
  '[ProductList] Get Product List',
  props<{ id: string }>(),
);

/**
 * Action to get a single ProductList through polling
 */
export const loadProductListPolling = createAction(
  '[ProductList] Load Product List polling',
  props<{ id: string }>(),
);

/**
 * Action to cancel get product list polling
 */
export const cancelProductListPolling = createAction(
  '[ProductList] Cancel Product List polling',
);

/**
 * Action to check and in case cancel get product list polling
 */
export const checkCancelProductListPolling = createAction(
  '[ProductList] Check cancel Product List polling',
  props<{ oldList?: List; newList: List }>(),
);

/**
 * Action to get a single ProductList Success
 */
export const loadProductListSuccess = createAction(
  '[ProductList] Get Product List Success',
  props<{ list: List; oldList?: List }>(),
);

/**
 * Action to get a single ProductList Failure
 */
export const loadProductListFailure = createAction(
  '[ProductList] Load Product List Failure',
);
